import React, { useEffect, useState } from "react";

function Weather2() {
  const [city, setCity] = useState("");
  const [wea, setWea] = useState(null);
  const [cityImage, setCityImage] = useState(null);
  const [loading, setLoading] = useState(false);

  const fetchWeather = (cityName) => {
    setLoading(true);

    fetch(`https://api.openweathermap.org/data/2.5/weather?q=${cityName || "Madurai"}&units=metric&appid=ae3976ae409ed459e492f7c45ba56941`)
      .then((res) => res.json())
      .then((data) => {
        setWea(data);

        return fetch(`https://api.unsplash.com/search/photos?page=1&query=${cityName || "Madurai"}`,
          {
            headers: {
              Authorization:
                "Client-ID E5l9vyjLlJFFLGj78XIQApVFYu7O947cLSP1tNVbArg",
            },
          }
        );
      })
      .then((res) => res.json())
      .then((imgData) => {
        setCityImage(imgData?.results?.[0]?.urls?.regular || null);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  };

  useEffect(() => {
    fetchWeather("Madurai");
  }, []);

  return (
    <div
      className="container-fluid vh-100 weather-app"
      style={{
        background: `linear-gradient(rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.3)), url(${cityImage || ""}) center / cover no-repeat`,
        background: `url(${cityImage || ""}) center / cover no-repeat  `,
      }}
    >
      <div className="row h-100">
        {/* LEFT SIDE */}
        <div className="col-lg-8 col-md-7 d-flex align-items-end p-5 text-white">
          <div>
            {loading && <h2>Loading...</h2>}

            {!loading && wea && (
              <>
                <h1 className="display-1 fw-light">
                  {wea?.main?.temp}°C
                  <span className="fs-2"> {wea?.name}</span>
                </h1>
                <p className="mb-1">Timezone: {wea?.timezone}</p>
                <div className="d-flex align-items-center">
                  <i className="bi bi-cloud fs-4 me-2"></i>
                  <span>{wea?.weather?.[0]?.main}</span>
                </div>
              </>
            )}

            {!loading && !wea && <h2>Enter a city to get weather</h2>}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-lg-4 col-md-5 sidebar text-white p-4">
          <div className="input-group mb-4">
            <input
              type="text"
              className="form-control   border-0 rounded-pill"
              placeholder="Another location"
              value={city}
              onChange={(e) => setCity(e.target.value)}
              onKeyDown={(e) =>
                e.key === "Enter" && fetchWeather(city)
              }
            />
            <button
              className="btn btn-warning rounded-0 ms-2"
              onClick={() => fetchWeather(city)}
            >
              <i class="fa fa-search" aria-hidden="true"></i>
            </button>
          </div>

          <hr />
          <h6 className="text-uppercase mt-4 mb-3">Weather Details</h6>

          <div className="detail-row">
            <span>Condition</span>
            <span>{wea?.weather?.[0]?.main || "-"}</span>
          </div>
          <div className="detail-row">
            <span>Humidity</span>
            <span>{wea?.main?.humidity || "-"}%</span>
          </div>
          <div className="detail-row">
            <span>Wind</span>
            <span>{wea?.wind?.speed || "-"} km/h</span>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Weather2;